import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { AUTHENTICATED_USER_QUERY_KEY } from "~/features/auth/api/auth/authQueries.ts";
import type { AuthenticatedUser } from "~/features/auth/api/auth/authTypes.ts";
import AuthContextProvider from "~/features/auth/contexts/AuthContextProvider/AuthContextProvider.tsx";
import Error404Page from "~/pages/Error404Page.tsx";

interface MyRouterContext {
    auth: {
        user: AuthenticatedUser | null;
    };
    queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    beforeLoad: ({ context }) => {
        // Read from your existing query cache
        const user = context.queryClient.getQueryData<AuthenticatedUser | null>(AUTHENTICATED_USER_QUERY_KEY) ?? null;
        return { auth: { user } };
    },
    component: RootComponent,
    notFoundComponent: Error404Page,
});

function RootComponent() {
    const { auth } = Route.useRouteContext();

    return (
        <AuthContextProvider user={auth.user}>
            <Outlet />
        </AuthContextProvider>
    );
}
